export const LAUNDRY_ACCESSORIES_DRAWER = 'Laundry Accessories';
export const WASHER = 'Washer';
export const DRYER = 'Dryer';
export const ACCESSORIES = 'Accessories';
export const NONE_VALUE = 'None';
export const LAUNDRY_ADD_TO_CART = 'bundle-mini.laundryBipAddToCart';
export const LAUNDRY_VIEW_BUNDLE = 'bundle-mini.viewBundleClick';

export const BMSM = 'BMSM';

export const BUNDLE_PAGE_SIZE = 16;
